import { entrar, getToken } from "../services/auth";

export const formatArrayForAddProductsTelevendas = (InfoProdutos, indexPriceTable = 0, clientInfo = {}, parameterPhoto = 'N', editProduct = false) => {
  const validationFlex = InfoProdutos?.totalDigitado > 0 ? true : false
  let tagPrice = indexPriceTable === 0 ? 'preco_venda' : 'preco_venda' + indexPriceTable
  if( InfoProdutos?.pessoa_preco  ) tagPrice = 'preco_venda'
  const codigo = InfoProdutos.codigo;
  const id_televendas = InfoProdutos?.id_televendas ?? 0;
  const nome = InfoProdutos.nome;
  const foto_descricao = InfoProdutos?.foto_descricao || "";
  const nome_web = InfoProdutos?.nome_web || InfoProdutos.nome;
  const id_produto = editProduct ?   InfoProdutos.id_produto : InfoProdutos?.id ?? InfoProdutos.id_produto;
  const preco_venda = InfoProdutos.preco_venda;
  const preco_web = InfoProdutos.preco_venda;
  const preco_compra = InfoProdutos?.preco_compra || 0.0;
  const quantidade = InfoProdutos?.qtd || InfoProdutos?.quantidade || 1;
  const qtd = quantidade
  // const total =  clientInfo?.pessoa_preco?.length === 0 ? validationFlex ? InfoProdutos.total : InfoProdutos[tagPrice] * quantidade : preco_venda * quantidade;
  const total =  validationFlex ? InfoProdutos.total : InfoProdutos[tagPrice] * quantidade 
  // antigo
  // let valor   = total
  let valor  = InfoProdutos[tagPrice]
  const preco_original = InfoProdutos?.preco_original ? InfoProdutos['preco_original'] = InfoProdutos.preco_venda : InfoProdutos.preco_venda 
  const preco_venda0 = valor;
  const observacao = InfoProdutos?.obs || InfoProdutos?.observacao || "";
  const preco_venda1 = InfoProdutos.preco_venda1;
  const preco_venda2 = InfoProdutos.preco_venda2;
  const preco_venda3 = InfoProdutos.preco_venda3;
  const preco_venda4 = InfoProdutos.preco_venda4;
  const preco_venda5 = InfoProdutos.preco_venda5;
  const preco_venda6 = InfoProdutos.preco_venda6;
  const subtotal = total;
  const desconto = 0;
  const status = "A";
  const pessoa_preco = InfoProdutos?.pessoa_preco ?? [];
  const array = [];
  const index_nome_tabela = parameterPhoto === 'S' ? indexPriceTable : 0;
  const nome_tabela =  InfoProdutos?.nome_tabela ?? 'PADRÃO'
  const estoque =  InfoProdutos.estoque
  const id_vendedor =  parseInt(getToken('ID_VENDEDOR'))
  
  array.push({
    codigo, nome, id_produto, preco_venda, preco_web, preco_compra, quantidade, qtd, id_televendas, valor,
    subtotal, desconto, status, preco_original, preco_venda0, preco_venda1, preco_venda2, preco_venda3, preco_venda4, preco_venda5,
    preco_venda6, pessoa_preco, total, nome_web, foto_descricao, observacao, parameterPhoto,  index_nome_tabela, nome_tabela, id_vendedor, 
    estoque
  });

  return array;
};

export const validationTablePrice = (InfoProdutos, indexPriceTable, clientInfo) => {
  if (!Array.isArray(InfoProdutos) || !InfoProdutos.length) return { valid: false, message: "Produto inválido."};
  const produto = InfoProdutos[0];

  if (clientInfo?.pessoa_preco?.length === 0 && produto.preco_venda === 0) return { valid: false, message: "Não pode inserir produto com tabela de preço zerada!",};

  if ( clientInfo?.tabela_padrao && produto["preco_venda" + clientInfo.tabela_padrao] === 0 && clientInfo?.pessoa_preco?.length === 0) return { valid: false, message: "Não pode inserir produto com tabela de preço zerada!"}

  if ( produto["preco_venda" + indexPriceTable] === 0 && clientInfo?.pessoa_preco?.length === 0) return { valid: false, message: "Não pode inserir produto com tabela de preço zerada!"};

  return {
    valid: true,
    InfoProdutos,
    message:''
  };
};

export const getReorder = () => {
  const element = JSON.parse(getToken('REORDER'));
  return !!element ? element : [];
};

export const validationReorder = (products, indexPriceTable =0) => {
  const newProduct = {...products}
  const reorder = getReorder();
  if (!!reorder?.length > 0) {
    reorder[0].televendas_produtos.forEach(item => {
      if (item.id_produto === newProduct.id) {
        newProduct.quantidade = item.quantidade;
        newProduct.qtd = item.quantidade;
        newProduct.observacao = item.observacao;
        newProduct.obs = item.observacao;
        // newProduct.total = indexPriceTable > 0 ? newProduct['preco_venda' + indexPriceTable] * newProduct?.quantidade ?? newProduct?.qtd : newProduct.preco_venda * newProduct?.quantidade ?? newProduct?.qtd
        newProduct.total = item.total
        newProduct.nome_tabela = item.nome_tabela
        newProduct.subtotal = newProduct.total
        newProduct.valor = (newProduct.total/newProduct.qtd )
        newProduct['id_produto'] = item.id_produto;
        newProduct['id_televendas'] = 0;
      }
    });
    return newProduct;
  }
};

export const getClientInfo = () => {
  const element = JSON.parse(getToken('clientInfo'));
  return !!element ? element : []
}

export const sum = (array, tag) =>  array.reduce((acc, currentValue) =>  acc + currentValue[tag],0)

export const saveLocalStorage = (key,array) =>  entrar(key, JSON.stringify(array));

export const workFlex = () => JSON.parse(getToken('site_trabalha_flex')) === 'S' ? true : false;

export const parameterPhoto = () => JSON.parse(getToken('site_trabalha_foto_televendas_sisteshop')) === 'S' ? true : false;

export const hiddenTablePrice = () => JSON.parse(getToken('site_esconde_tabela_padrao')) === 'S' ? true : false;

export const stockTeleSale = () => JSON.parse(getToken('estoque_televendas'))?.toLowerCase?.() || 'loja';

export const hiddenTablePriceWithTableDefault = () => { 
  const clientInfo = getClientInfo()
  if(clientInfo?.tabela_padrao > 0) return 'preco_venda'+ clientInfo?.tabela_padrao
  return hiddenTablePrice() ? 'preco_venda'+1 : 'preco_venda'
};

export const validationStock= () => JSON.parse(getToken('site_verificar_produto_estoque')) === 'S' ? true : false;

export const hiddenPricesTables = () => JSON.parse(getToken('site_esconder_preco_tabelas')) === 'S' ? true : false;

export const parameterObs = () => JSON.parse(getToken('obs_fixa_televendas')) ?? ''

export const insertTablePriceProduct = (product, itemTablePrice) => {
  const prod = {...product}
  prod.preco_venda = itemTablePrice.preco_venda;
  prod.preco_venda0 = itemTablePrice.preco_venda;
  prod.preco_venda1 = itemTablePrice.preco_venda1;
  prod.preco_venda2 = itemTablePrice.preco_venda2;
  prod.preco_venda3 = itemTablePrice.preco_venda3;
  prod.preco_venda4 = itemTablePrice.preco_venda4;
  prod.preco_venda5 = itemTablePrice.preco_venda5;
  prod.preco_venda6 = itemTablePrice.preco_venda6;
  return prod
}

export const updateOneProductLocalStorage = (index, item) => {
  const clientInfo = getClientInfo()
  clientInfo.televendas_produtos[index] = item
  saveLocalStorage('clientInfo', clientInfo)

}

export  const validarTagPriceOrParameterPhoto = (item) => {
  // console.log(item.total,item?.quantidade, item?.index_nome_tabela, item?.index_nome_tabela  )
  let tagName = item.index_nome_tabela > 0 && !item.pessoa_preco ? 'preco_venda'+item.index_nome_tabela : 'preco_venda'
  if(item?.index_nome_tabela >= 0  && parameterPhoto === "S" ){
      // if(item?.totalDigitado > item[tagName]) return item.totalDigitado 
      // return item[tagName]
      return (item.total / item?.quantidade || item?.qtd || 1)
    }
    if((item?.index_nome_tabela === undefined || item?.index_nome_tabela === null) && parameterPhoto === "S") return item[tagName]
    if(item?.pessoa_preco) return item?.valor ?? 0
    return(item.total / item?.quantidade ||  item?.qtd || 1)
  // return item[tagPrice] ?? 0
}

export const isIphone = () => {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPod/i.test(navigator.userAgent);
}

export const deleteFormOfPayment = (element = []) => {
  if(Array.isArray(element) && element.length > 0){
    const newArray = element.map(item => {
        delete item.desconto
        return item
    })
    return newArray
  }
  return []
}
